import React from "react";

import { Doc } from "affinityUI/structures/doc";

import navBarAndAddPatientLink from "./assets/Navigation bar and Add patient link.png";
import searchBarAndPatientCard from "./assets/Search bar and Patient card.png";
export const ReviewResultsSection: React.FC = () => {
  return (
    <Doc.Section title="Review Results">
      <p>
        The Entia Liberty dashboard will open on the home screen pictured below. It displays the most recent result
        first. There are four main elements to the page:
      </p>

      <ul>
        <li>
          <strong>Search bar (A)</strong> allows you to search for patients.
        </li>
        <li>
          <strong>Result card (B)</strong> displays a patient result.
        </li>
        <li>
          <strong>Navigation bar (C)</strong> allows you to navigate to other features in the dashboard depending on
          access.
        </li>
        <li>
          <strong>Add patient link (D)</strong> allows you to add a patient to the Entia Liberty dashboard who is or
          will be using the service.
        </li>
      </ul>
      <Doc.Illustration src={searchBarAndPatientCard} label="Search bar and Patient card" />
      <Doc.Illustration src={navBarAndAddPatientLink} label="Navigation bar and Add patient link" />
    </Doc.Section>
  );
};
